import React, { useState } from 'react';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { Input, Button, Card } from '../components/UI';

export default function ChildFormScreen({ user, navigate }) {
    const [name, setName] = useState('');
    const [dob, setDob] = useState('');
    const [gender, setGender] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || !dob || !gender) {
            setError("Semua kolom wajib diisi.");
            return;
        }
        setLoading(true);
        setError('');
        try {
            const childrenPath = `users/${user.uid}/children`;
            await addDoc(collection(db, childrenPath), {
                name,
                dob: Timestamp.fromDate(new Date(dob)),
                gender,
                ownerUid: user.uid
            });
            navigate('home');
        } catch (err) {
            console.error(err);
            setError("Gagal menyimpan data. Silakan coba lagi.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card>
            <form onSubmit={handleSubmit} className="space-y-4">
                <h2 className="text-xl font-bold text-center text-gray-800 mb-4">Informasi Data Anak</h2>
                {error && <p className="text-red-500 text-sm text-center">{error}</p>}
                <Input id="name" type="text" label="Nama Lengkap Anak" value={name} onChange={e => setName(e.target.value)} required />
                <Input id="dob" type="date" label="Tanggal Lahir" value={dob} onChange={e => setDob(e.target.value)} required />
                <div>
                    <label htmlFor="gender" className="block text-gray-700 text-sm font-bold mb-2">Jenis Kelamin</label>
                    <select id="gender" value={gender} onChange={e => setGender(e.target.value)} className="input-field" required>
                        <option value="" disabled>Pilih Jenis Kelamin</option>
                        <option value="Laki-laki">Laki-laki</option>
                        <option value="Perempuan">Perempuan</option>
                    </select>
                </div>
                <Button type="submit" disabled={loading}>{loading ? 'Menyimpan...' : 'Simpan Data Anak'}</Button>
            </form>
        </Card>
    );
}
